/* Source: src/mt-includes/js/src/core/media/init.js*/
angular.module('website.core.media', []);